import { gql } from "@apollo/client";
import { useQueryWithSimpleErrorHandling } from "hooks";

 export const APPLICATION_FEATURE_FLAG_QUERY = gql`
  query applicationFeatureFlag($code: String!) {
    applicationFeatureFlag(code: $code)
  }
`;

export function useApplicationFeature(code) {
  const { data } = useQueryWithSimpleErrorHandling(APPLICATION_FEATURE_FLAG_QUERY, {
    variables: { code },
    skip: !code
  });

  const enabled = data?.applicationFeatureFlag;
  return { enabled };
}
